import { getJq } from 'www/core';


export const contactFormInit = (presets=null) => {
  const $ = getJq();
  const dropdownApplication = $('#lead_application_type');
  const dropdownIndoorRoom = $('#project-indoor-room-type');
  const dropdownOutdoorRoom = $('#project-outdoor-room-type');
  const dropdownIndoorFloor = $('#project-indoor-floor-type');
  const dropdownIndoorSubfloor = $('#project-indoor-subfloor-type');
  const dropdownOutdoorFloor = $('#project-outdoor-floor-type');
  const dropdownChanged = () => {
    if (presets.environment === 'Indoor' || dropdownApplication.val() === 'Floor Heating') {
      dropdownIndoorRoom.show();
      dropdownIndoorFloor.show();
      dropdownIndoorSubfloor.show();
      dropdownOutdoorRoom.hide();
      dropdownOutdoorFloor.hide();
    }
    else if (presets.environment === 'Outdoor' || dropdownApplication.val() === 'Snow Melting') {
      dropdownIndoorRoom.hide();
      dropdownIndoorFloor.hide();
      dropdownIndoorSubfloor.hide();
      dropdownOutdoorRoom.show();
      dropdownOutdoorFloor.show();
    }
    else {
      dropdownIndoorRoom.hide();
      dropdownIndoorFloor.hide();
      dropdownIndoorSubfloor.hide();
      dropdownOutdoorRoom.hide();
      dropdownOutdoorFloor.hide();
    }
  };
  dropdownChanged();
  if (presets) {
    $('select[name*=application_type]').val(presets.environment === 'Outdoor' ? 'Snow Melting' : 'Floor Heating');
    if (presets.environment === 'Outdoor') {
      $('select[name*=room_type_outdoor]').val(pFind(presets.roomType, presets.roomTypeOptions));
      $('select[name*=floor_type_outdoor]').val(pFind(presets.floorType, presets.floorTypeOptions));
    }
    else {
      $('select[name*=room_type_indoor]').val(pFind(presets.roomType, presets.roomTypeOptions));
      $('select[name*=floor_type_indoor]').val(pFind(presets.floorType, presets.floorTypeOptions));
      $('select[name*=subfloor_type]').val(pFind(presets.subfloorType, presets.subfloorTypeOptions));
    }
  }

  dropdownApplication.change(dropdownChanged); // Bind after to prevent flashing
};

const pFind = (needle, haystack) => haystack && haystack.find
  ? haystack.find(({ key }) => key === needle).value : null;
